import {Component, OnInit, PLATFORM_ID, inject} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {RouterLink} from "@angular/router";
import {BookProjectApiService} from "../../core/services/book-project-api.service";
import {BookCoverApiService} from "../../core/services/book-cover-api.service";
import {Model, ModelService} from "../../core/services/model.service";
import {SharedBookProjectDto} from "../../core/models/book-project.model";
import {HeroWindowComponent} from "./hero-window/hero-window.component";
import {StudioTourComponent} from "./studio-tour/studio-tour.component";
import {StoryPromptComponent} from "./story-prompt/story-prompt.component";
import {RevealDirective} from "../shared/reveal.directive";
import {DoodleComponent} from "../shared/doodle/doodle.component";
import {hasStoredToken} from '../../core/services/session-token';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [RouterLink, HeroWindowComponent, StudioTourComponent, StoryPromptComponent, RevealDirective, DoodleComponent]
})
export class HomeComponent implements OnInit {

  private static readonly SHELF_SIZE = 4;
  private static readonly PLACEHOLDER_COVER_COUNT = 12;

  userIsLoggedIn: boolean;
  models: Model[] = [];
  featuredModelName = '';
  shelfBooks: SharedBookProjectDto[] = [];
  shelfCovers: { [id: string]: string } = {};

  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  constructor(private modelService: ModelService,
              private bookProjectApiService: BookProjectApiService,
              private bookCoverApiService: BookCoverApiService) {
  }

  ngOnInit() {
    this.userIsLoggedIn = hasStoredToken();

    this.models = this.modelService.getModels();
    this.featuredModelName = this.models[0]?.name ?? '';

    // The shelf changes daily, so it is fetched in the browser rather than baked into the prerendered page.
    if (this.isBrowser) {
      this.loadShelf();
    }
  }

  private loadShelf() {
    this.bookProjectApiService.getPublicBooks(1, HomeComponent.SHELF_SIZE).subscribe({
      next: response => {
        this.shelfBooks = response.data;
        this.shelfBooks.forEach((book, index) => this.loadCover(book, index));
      },
      // The shelf is a nice-to-have on the landing page; without books the section stays hidden.
      error: error => console.warn('Could not load public books for the landing page', error)
    });
  }

  private loadCover(book: SharedBookProjectDto, index: number) {
    this.bookCoverApiService.getBookCover(book.id).subscribe({
      next: coverBlob => {
        const reader = new FileReader();
        reader.onloadend = () => this.shelfCovers[book.id] = reader.result as string;
        reader.readAsDataURL(coverBlob);
      },
      error: () => {
        const placeholder = (index % HomeComponent.PLACEHOLDER_COVER_COUNT) + 1;
        this.shelfCovers[book.id] = `assets/images/book-cover-placeholder${placeholder}.webp`;
      }
    });
  }
}
